<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>
        {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_EMBEDED_TITLE' | translate }}
      </span>

      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content overflowShadow>
    <div class="content__body">
      <div class="content__img-section">
        <img
          class="flex-1"
          src="./assets/img/commissioningv2/device-black-{{
            (commissioningService.selectedDevice$ | async).icon
          }}.png"
          alt=""
        />
      </div>

      <div class="content__room-selection">
        <div class="room-selection__header">
          {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_EMBEDED_SUBTITLE' | translate }}
        </div>
        <div class="room-selection__wrapper" #overflowShadowObservedElement>
          <mat-radio-group
            class="room-selection__radio-group"
            [(ngModel)]="selectedOption"
            (ngModelChange)="onRoomOptionSelect($event)"
          >
            <mat-radio-button *ngFor="let option of radioOptions" color="primary" [value]="option">
              <span class="radio__name">{{ option.name | translate }}</span>
            </mat-radio-button>
          </mat-radio-group>

          <div
            class="room-selection__form-wrapper"
            *ngIf="selectedOption.type === AddRoomOptionType.NewRoom"
          >
            <form class="room-selection__room-name-wrapper" [formGroup]="addNewRoomFormGroup">
              <mat-form-field class="room-selection__room-name" mat-input-height-small>
                <input
                  matInput
                  formControlName="name"
                  fieldTextContentTooltip
                  [placeholder]="
                    '+SRC_COMMISSIONINGV2.ADD_ROOM_EMBEDED_ROOM_NAME_INPUT' | translate
                  "
                />

                <mat-error
                  data-at-add-room-modal-error-not-unique-room
                  *ngIf="addNewRoomFormGroup.controls.name.hasError('notUnique')"
                >
                  {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_ROOM_NOT_UNIQUE' | translate }}
                </mat-error>
                <mat-error
                  data-at-add-room-modal-error-too-long
                  *ngIf="addNewRoomFormGroup.controls.name.hasError('maxlength')"
                >
                  {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_TOO_LONG_ROOM_NAME' | translate }}
                </mat-error>
                <mat-error
                  data-at-add-room-modal-error-not-valid
                  *ngIf="addNewRoomFormGroup.controls.name.hasError('pattern')"
                >
                  {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_NOT_VALID_ROOM_NAME' | translate }}
                </mat-error>
                <mat-error
                  data-at-add-room-modal-error-required
                  *ngIf="addNewRoomFormGroup.controls.name.hasError('required')"
                >
                  {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_REQUIRED_ROOM_NAME' | translate }}
                </mat-error>
              </mat-form-field>

              <div class="room-selection__room-type">
                <mat-form-field mat-select-height-small>
                  <mat-label>{{
                    '+SRC_COMMISSIONINGV2.ADD_ROOM_EMBEDED_ROOM_TYPE_INPUT' | translate
                  }}</mat-label>
                  <mat-select formControlName="type">
                    <mat-select-trigger>
                      <span>
                        {{
                          '+INSTALLATIONS.INSTALLATION.SRC.ROOM.' +
                            addNewRoomFormGroup.controls.type?.value | translate
                        }}
                      </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let option of roomTypeOptions" [value]="option">
                      {{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM.' + option | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <button
                  gtm="onPreviousStep"
                  gtmAction="Add room"
                  gtmCategory="addRoomModal"
                  mat-raised-button
                  color="primary"
                  [disabled]="!addNewRoomFormGroup.valid"
                  (click)="addRoom()"
                >
                  {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_EMBEDED_ADD_ROOM_BUTTOM' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      data-at-add-room-modal-back-btn
      gtm="onPreviousStep"
      gtmAction="Previous step"
      gtmCategory="addRoomModal"
      mat-button
      color="primary"
      (click)="navigateBack()"
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
    <button
      data-at-add-room-modal-next-btn
      gtm="onNextStep"
      gtmAction="Next step"
      gtmCategory="addRoomModal"
      mat-raised-button
      color="primary"
      (click)="navigateForward()"
      [disabled]="selectedOption.type === AddRoomOptionType.NewRoom"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
